import { connect } from 'react-redux';
import { IState } from '../../../store';
import { ILegalSupportDemand, LegalSupportDemand } from './LegalSupportDemand';
import { selectOffer } from '../../../components/CostEstimate/selectors/selectOffer';
import { getBanner } from './getBanner';
import { Dispatch } from 'redux';
import { trackInViewPort } from '../../../actions/requestDemand';
import { EDemandBlockTypes } from '../../../constants/requestDemand';

export const LENDING_URL = 'https://promo.cian.ru/legal-support/';

export const mapStateToProps = (state: IState): Partial<ILegalSupportDemand> => {
  const offer = selectOffer(state);
  const banner = getBanner(offer);

  return {
    banner,
    lendingUrl: LENDING_URL,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  onShownInViewPort(visible: boolean) {
    dispatch(trackInViewPort(EDemandBlockTypes.CHECK_CLEAN, visible));
  },
});

export const LegalSupportDemandContainer = connect(mapStateToProps, mapDispatchToProps)(LegalSupportDemand);
